<main class="container-fluid">
    <article class="row row bg-white shadow mb-3 mt-3 ml-0 mr-0">
      <section class="col-12 p-4 mb-5">
  
        <div class="d-flex justify-content-between">
          <div>
            <img src="../../../../../assets/icons/solicitud.png" class="d-inline-block img-responsive mr-3" alt="">
            <label class="h5">Listado de reporte formulario</label>
          </div>
          <p>
            <button type="button" class="btn btn-outline-success mr-3" (click)="isExportar = !isExportar" [attr.aria-expanded]="!isExportar">Exportar</button>
            <button type="button" class="btn btn-outline-primary" (click)="isCollapsed = !isCollapsed"
              [attr.aria-expanded]="!isCollapsed" aria-controls="filtros">
              Ver filtros
            </button>
          </p>
        </div>

        <div id="exportar-form" *ngIf="!isExportar">
          <div class="card mb-3">
            <div class="card-body">
              <form [formGroup]="exportarForm" (submit)="submit()">
                  <div class="row">
                    <div class="col-2 mb-2 input-group-prepend" formArrayName="exportarList" *ngFor="let order of exportarForm.controls.exportarList.controls; let i = index">
                      <div class="input-group-text">
                        <input type="checkbox" [formControlName]="i">
                      </div>
                      <label class="label label-primary medium" for="">{{exportarList[i].name}}</label>
                  </div>  
                  <div class="col-4 mb-2 input-group-prepend" >
                    <div class="input-group-text">
                      <input type="checkbox" formControlName="selectAll">
                    </div>
                    <label class="label label-primary medium" for="">Seleccionar/Deseleccionar Todo</label>
                  </div> 
                  <div class="col-6"></div>
                  <div class="col-2">
                      <button class="btn btn-success m-auto" type="submit" [disabled]="!exportarForm.valid">Exportar</button>
                  </div>
                    </div>
              </form>
                </div>
              </div>
            </div> 
      
        <div id="filtros" [ngbCollapse]="isCollapsed">
          <div class="card mb-3">
            <div class="card-body">
              <form [formGroup]="filtro" (submit)="filtrar()">
                <div class="row">
                    <div class="col-2 form-group" *ngIf="!authService.getRolUser(adminCC)">
                      <label class="small text-secondary" for="codigo_camara">Cámara de Comercio</label>
                      <select class="form-control form-control-sm" id="codigo_camara" formControlName="codigo_camara">
                        <option class="" value="" selected="true">
                          Seleccione
                        </option>
                        <option class="" *ngFor="let option of camarasLista; let i = index"
                          value="{{option?.codigo_camara}}" [selected]="false">
                          {{option?.desc_camara}}
                        </option>
                      </select>
                    </div>
                    <div class="col-2 form-group">
                        <label class="text-secondary small">Fecha inicial</label>
                        <div class="input-group">
                          <input class="form-control form-control-sm" formControlName="fecha_inicial" placeholder="yyyy/mm/dd"
                            ngbDatepicker #inicio="ngbDatepicker" (dateSelect)="onCheckDate($event)">
                          <div class="input-group-append">
                            <button class="btn btn-outline-secondary calendar" (click)="inicio.toggle()" type="button"></button>
                          </div>
                        </div>
                      </div>
                      <div class="col-2 form-group">
                        <label class="text-secondary small">Fecha final</label>
                        <div class="input-group">
                          <input class="form-control form-control-sm" formControlName="fecha_final" placeholder="yyyy/mm/dd"
                              ngbDatepicker #fin="ngbDatepicker" [minDate]="fecha_inicio">
                          <div class="input-group-append">
                            <button class="btn btn-outline-secondary calendar" (click)="fin.toggle()" type="button"></button>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex flex-row">
                          <button type="reset" class="btn btn-outline-primary border-0 m-auto btn-align-vertical"
                            (click)="limpiar()">Limpiar</button>
                          <button class="btn btn-primary m-auto solicitud-btn-principal btn-align-vertical" type="submit">Filtrar</button>
                      </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        
        <div class="table-responsive">
          <app-tablas [page] = "paginaActual" [headers]="headerTabla" [sizeData]="dataTabla.paging.totalItems" (paginado)="onPaginado($event)"
            class="table-responsive">
            <tr *ngFor="let item of dataTabla.items; let i=index" class="small">
              <td>{{item.desc_camara}}</td>
              <td>{{item.desc_solicitud}}</td>
              <td>{{item.sin_radicar}}</td>
              <td>{{item.en_tramite}}</td>
              <td>{{item.aprobada}}</td>
              <td>{{item.no_aprobada}}</td>
              <td>{{item.rechazada}}</td>
            </tr>
          </app-tablas>
        </div>
      </section>
    </article>
  </main>